import { render, staticRenderFns } from "./CommunityFaqCreate.vue?vue&type=template&id=7bf0e846"
import script from "./CommunityFaqCreate.vue?vue&type=script&lang=js"
export * from "./CommunityFaqCreate.vue?vue&type=script&lang=js"
import style0 from "./CommunityFaqCreate.vue?vue&type=style&index=0&id=7bf0e846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports